<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>{{
            ffExportDetail.containerInfo == "lcl"
              ? "Execution-LCL Consolidation"
              : "Execution-FCL Consolidation"
          }}</b-navbar-brand>
        </b-navbar>

        <banner-component :allModuleIdBanner="WarehouseStuffing.allModuleId ? WarehouseStuffing.allModuleId : ''
          " :jobSeriesBanner="WarehouseStuffing.ffExportFclConsoSeries
            ? WarehouseStuffing.ffExportFclConsoSeries
            : ''
            " :bannerClientName="WarehouseStuffing.clientName ? WarehouseStuffing.clientName : ''
              " :trackingId="trackingId != '' ? trackingId : ''" iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <div>

              <ContainerComponent v-if="WarehouseStuffing.allModuleId"
                :allModuleIdContainer="WarehouseStuffing.allModuleId ? WarehouseStuffing.allModuleId : ''" JOB="FF" />
              <!-- *******************************  Start  WareHouse  Warehouse Stuffing At ICD *****************************-->
              <md-layout gutter v-if="proceedNext == '1'">
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="40">
                  <label>
                    <b>
                      <u>{{
                        ffExportDetail.portType == "Icd"
                          ? "Warehouse Stuffing At ICD"
                          : " Warehouse Stuffing At PORT"
                      }}</u>
                    </b>
                  </label>
                </md-layout>

              </md-layout>


              <md-layout gutter class="labelMargtop">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>Name of CFS Where Stuffing is done</label>
                    <b-form-input :formatter="capitalizeAll" name="nameOfCFS" id="nameOfCFS"
                      v-model="WarehouseStuffing.nameOfCFS"></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!WarehouseStuffing.nameOfCFS">{{
                    errorMainExecution.nameOfCFS
                  }}</span>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Container No.(AAAA1234567)</label>
                    <b-form-input :formatter="capitalizeAll" name="fclConcontainerNo" id="fclConcontainerNo"
                      v-model="WarehouseStuffing.fclConcontainerNo" @input="containerNoRegexfun"></b-form-input>
                  </md-layout>
                  <span class="error" v-if="containerNoRegexError != ''">{{
                    containerNoRegexError
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="25">
                  <label>Container Type/Size</label>
                  <model-list-select option-value="containerTypeId" option-text="containerType"
                    :list="ContainerTypeList" placeholder="Select Container Type/Size"
                    v-model="WarehouseStuffing.containerTypeId"></model-list-select>

                  <span class="error" v-if="!WarehouseStuffing.containerTypeId">{{
                    errorMainExecution.containerTypeId
                  }}</span>
                </md-layout> -->
              </md-layout>
              <!-- <md-layout gutter class="gutr">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>Line Seal No.</label>
                    <b-form-input :formatter="capitalizeAll" name="lineSealNo" id="lineSealNo"
                      v-model="WarehouseStuffing.lineSealNo"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>Custom Seal No.</label>
                    <b-form-input :formatter="capitalizeAll" name="customSealNo" id="customSealNo"
                      v-model="WarehouseStuffing.customSealNo"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Container Tare Wgt.(tons)</label>
                    <b-form-input :formatter="capitalizeAll" name="tareWeight" id="tareWeight"
                      v-model="WarehouseStuffing.tareWeight" type="number" min="0"></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Container Gross Wgt.(tons)</label>
                    <b-form-input :formatter="capitalizeAll" name="conGrossWeight" id="conGrossWeight" type="number"
                      min="0" v-model="WarehouseStuffing.conGrossWeight"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout> -->
              <!-- <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="10">
                  <md-layout md-flex="100">
                    <label>Measurement (in CBM)</label>
                    <b-form-input :formatter="capitalizeAll" name="noOfpkgUnit" id="noOfpkgUnit" type="number" min="0"
                      v-model="WarehouseStuffing.measurement"></b-form-input>
                    <span class="error" v-if="!WarehouseStuffing.measurement">{{
                      errorMainExecution.measurement
                    }}</span>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="10">
                  <md-layout md-flex="100">
                    <label>Net Wgt.</label>
                    <b-form-input :formatter="capitalizeAll" id="netWeight" name="netWeight" type="number" min="0"
                      v-model="WarehouseStuffing.netWeight"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="10">
                  <label for="weightUnit">Unit</label>
                  <model-list-select :list="unitList" option-value="uV" option-text="uT" placeholder="Select"
                    name="weightUnit" id="weightUnit" v-model="WarehouseStuffing.weightUnit"></model-list-select>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label>Package Details</label>
                  <model-list-select :list="packageNameList" id="clientId" v-model="WarehouseStuffing.packageId"
                    option-value="packageId" option-text="packageName"
                    placeholder="Select  Package Name"></model-list-select>

                  <span class="error" v-if="!WarehouseStuffing.packageId">{{
                    errorMainExecution.packageId
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>No of {{ WarehouseStuffing.packageName }}</label>
                    <b-form-input :formatter="capitalizeAll" name="noOfpkgUnit" id="noOfpkgUnit" type="number" min="0"
                      :disabled="WarehouseStuffing.packageName == '' ? true : false"
                      v-model="WarehouseStuffing.noOfpkgUnit"></b-form-input>
                    <span class="error" v-if="!WarehouseStuffing.noOfpkgUnit">{{
                      errorMainExecution.noOfpkgUnit
                    }}</span>
                  </md-layout>
                </md-layout>
              </md-layout> -->
              <md-layout gutter class="gutr">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Cargo Stuffing Date</label>
                  <date-picker :format="selectDateFormat" lang="en" name="cargoStuffingDate" id="cargoStuffingDate"
                    v-model="WarehouseStuffing.cargoStuffingDate" :minute-step="1"></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Handover Date</label>
                  <date-picker :format="selectDateFormat" lang="en" name="handoverDate" id="handoverDate"
                    v-model="WarehouseStuffing.handoverDate" :minute-step="1"></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>VGM Submission Date</label>
                  <date-picker :format="selectDateFormat" lang="en" name="vgmSubmissionDate" id="vgmSubmissionDate"
                    v-model="WarehouseStuffing.vgmSubmissionDate" :minute-step="1"></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label for="gateInDate">SI Submission date</label>
                  <date-picker lang="en" id="gateInDate" type="datetime" :minute-step="1" name="gateInDate"
                    v-model="WarehouseStuffing.siSubmissionDate"></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label for="trSubmissionDate">TR Submission date</label>
                  <date-picker lang="en" id="trSubmissionDate" type="datetime" :minute-step="1" name="trSubmissionDate"
                    v-model="WarehouseStuffing.trSubmissionDate"></date-picker>
                </md-layout>
              </md-layout>

              <hr class="hr-border" v-if="clientList.length > 0 || clientDataModel.execConClientId != ''" />
              <div v-if="clientList.length > 0 || clientDataModel.execConClientId != ''">
                <md-layout md-gutter>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="95">
                    <label>
                      <b>
                        <u>
                          Client Details
                          <span class="error" v-if="sbDetailArrayList.length == 0">{{
                            errorAtleastSb
                          }}</span>
                        </u>
                      </b>
                    </label>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <label for="clientId" v-if="clientDataModel.execConClientId == ''">Existing Client Name</label>
                    <model-list-select v-if="clientDataModel.execConClientId == ''" :list="clientList"
                      id="clientNamenew" v-model="clientDataModel.clientId" option-value="clientId"
                      option-text="clientName" placeholder="Select Existing Client Name"></model-list-select>
                    <md-layout md-flex="100" v-else>
                      <label for="clientId">Existing Client Name</label>
                      <b-form-input :formatter="capitalizeAll" v-model="clientDataModel.clientName"
                        disabled></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!clientDataModel.clientId">{{
                      errorClientList.clientId
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label>Carting Date</label>
                    <date-picker :format="selectDateFormat" lang="en" name="cartingDate" id="cartingDate"
                      v-model="clientDataModel.cartingDate" :minute-step="1"></date-picker>
                    <span class="error" v-if="!clientDataModel.cartingDate">{{
                      errorClientList.cartingDate
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <md-layout md-flex="100">
                      <label>CRN (Carting Order)</label>
                      <b-form-input :formatter="capitalizeAll" name="crnNumber" id="crnNumber"
                        v-model="clientDataModel.crnNumber"></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!clientDataModel.crnNumber">{{
                      errorClientList.crnNumber
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-input-container>
                      <label>Upload Client VGM</label>
                      <md-file name="vgmUpload" id="vgmUpload" v-model="clientDataModel.vgmUpload" multiple></md-file>
                    </md-input-container>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter>
                  <md-layout md-flex="85"></md-layout>
                  <md-layout md-flex="15">
                    <b-button variant="outline-info" style="margin-top: 40px" id="addButtonLoaderC"
                      @click="addClientWithMain">{{
                        clientDataModel.execConClientId == "" ? "Add" : "Edit"
                      }}
                      Client</b-button>
                    <md-spinner md-indeterminate id="loaderC" style="display: none"></md-spinner>
                  </md-layout>
                </md-layout>
              </div>
              <hr class="hr-border" v-if="getMultipleClientArry.length > 0" />
              <div class="box" v-if="getMultipleClientArry.length > 0">
                <div class="box-header">
                  <h4 class="box-title">
                    <u>Client Details</u>
                  </h4>
                </div>

                <!-- /.box-header -->
                <div class="box-body">
                  <table id="ffConClient" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Client Name</th>
                        <th>Carting Date</th>
                        <th>CRN</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in getMultipleClientArry" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td @click="viewEdit(item)" class="showMoreData">
                          {{ item.myclientName }}
                        </td>
                        <td>{{ item.cartingDate | moment }}</td>
                        <td>{{ item.crnNumber }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.box-body -->
              </div>

              <md-layout md-gutter class="gutr mt-2" v-if="
                sbLengthforAll.length == getMultipleClientArry.length &&
                getMultipleClientArry.length > 0
              ">
                <md-layout md-flex="90"></md-layout>
                <md-layout md-flex="10" v-if="
                  sbLengthforAll.length == getMultipleClientArry.length &&
                  getMultipleClientArry.length > 0
                ">
                  <b-button size="sm" variant="outline-info" @click="showMoreSBDet">{{ showMoreSB == true ? "Hide" :
                    "Add More" }} S/B</b-button>
                  <md-spinner md-indeterminate id="loader1" style="display: none"></md-spinner>
                </md-layout>
              </md-layout>

              <div v-if="
                (sbLengthforAll.length != getMultipleClientArry.length &&
                  getMultipleClientArry.length > 0) ||
                showMoreSB ||
                SBDetail.conshippingSBId != ''
              ">
                <hr class="hr-border" />
                <md-layout md-gutter style="margin-top: 1%">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="95">
                    <label>
                      <b>
                        <u>
                          Client Shipping Details
                          <span class="error" v-if="sbDetailArrayList.length == 0">{{
                            errorAtleastSb
                          }}</span>
                        </u>
                      </b>
                    </label>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <label for="clientId">Client Name</label>
                    <model-list-select :list="clientListSbDetail" id="clientId" v-model="SBDetail.clientId"
                      option-value="clientId" option-text="clientName"
                      placeholder="Select  Client Name"></model-list-select>
                    <span class="error" v-if="!SBDetail.clientId">{{
                      errorSBExecution.clientId
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label>Shipping Bill Date</label>
                    <date-picker :format="selectDateFormat" lang="en" name="shippingBillDate" id="shippingBillDate"
                      v-model="SBDetail.shippingBillDate" :minute-step="1"></date-picker>
                    <span class="error" v-if="!SBDetail.shippingBillDate">{{
                      errorSBExecution.shippingBillDate
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Shipping Bill No.</label>
                      <b-form-input :formatter="capitalizeAll" name="shippingBillNo" id="shippingBillNo"
                        v-model="SBDetail.shippingBillNo"></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!SBDetail.shippingBillNo">{{
                      errorSBExecution.shippingBillNo
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <md-layout md-flex="100">
                      <label>Cargo Gross Weight(tons)</label>
                      <b-form-input :formatter="capitalizeAll" name="cargoGrossWeight" id="cargoGrossWeight"
                        v-model="SBDetail.cargoGrossWeight"></b-form-input>
                    </md-layout>
                    <span class="error" v-if="!SBDetail.cargoGrossWeight">{{
                      errorSBExecution.cargoGrossWeight
                    }}</span>
                  </md-layout>
                </md-layout>
                <md-layout gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="10">
                    <md-layout md-flex="100">
                      <label>Measurement(CBM)</label>
                      <b-form-input :formatter="capitalizeAll" name="measurementCBM" id="measurementCBM"
                        v-model="SBDetail.measurementCBM"></b-form-input>
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="10">
                    <md-layout md-flex="100">
                      <label>Net Wgt.</label>
                      <b-form-input :formatter="capitalizeAll" id="netWeight" name="netWeight" type="number" min="0"
                        v-model="SBDetail.netWeight"></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="10">
                    <label for="weightUnit">Unit</label>
                    <model-list-select :list="unitList" option-value="uV" option-text="uT" placeholder="Select"
                      name="weightUnit" id="weightUnit" v-model="SBDetail.weightUnit"></model-list-select>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <label>Package Details</label>
                    <model-list-select :list="packageNameList" id="clientId" v-model="SBDetail.packageId"
                      option-value="packageId" option-text="packageName"
                      placeholder="Select  Package Name"></model-list-select>

                    <span class="error" v-if="!SBDetail.packageId">{{
                      errorMainExecution.packageId
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <md-layout md-flex="100">
                      <label>No of {{ SBDetail.packageName }}</label>
                      <b-form-input :formatter="capitalizeAll" name="noOfpkgUnit" id="noOfpkgUnit" type="number" min="0"
                        :disabled="SBDetail.packageName == '' ? true : false"
                        v-model="SBDetail.noOfpkgUnit"></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>

                <md-layout gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <label>LEEO (Let Export Permit) Date</label>
                    <date-picker :format="selectDateFormat" lang="en" name="leeoDate" id="leeoDate"
                      v-model="SBDetail.leeoDate" :minute-step="1"></date-picker>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>LEEO (Let Export Permit) No.</label>
                      <b-form-input :formatter="capitalizeAll" name="leeoNo" id="leeoNo"
                        v-model="SBDetail.leeoNo"></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>

                <md-layout gutter>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="30">
                    <md-input-container>
                      <label>Upload Invoice From Client</label>
                      <md-file placeholder="Click to Upload  Invoice From Client" name="invoiceUpload"
                        id="invoiceUpload" v-model="SBDetail.invoiceUpload" @selected="onFileChangeInvoice"
                        multiple></md-file>
                    </md-input-container>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="25">
                    <md-input-container>
                      <label>Upload Cargo Packing List</label>
                      <md-file placeholder="Click to Upload Cargo Packing List" name="cargoUpload" id="cargoUpload"
                        v-model="SBDetail.cargoUpload" @selected="onFileChangeCargo" multiple></md-file>
                    </md-input-container>
                  </md-layout>
                  <md-layout md-flex="15"></md-layout>
                  <md-layout md-flex="20">
                    <b-button style="margin-top: 40px" variant="outline-info" id="addButtonLoaderSB"
                      @click="addSBDetail">{{ SBDetail.conshippingSBId == "" ? "Add" : "Edit" }} S/B
                      Detail</b-button>
                    <md-spinner md-indeterminate id="loaderSB" style="display: none"></md-spinner>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter v-if="viewInvoicedDoc.length > 0 || viewCargoDoc.length > 0">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20" v-for="(item, index) in viewInvoicedDoc" :key="index">
                    <a :href="`${this.docURL}/FFExecutionSBWareHouse/` + item" target="_blank" download>View Document -
                      {{ index + 1 }}</a>
                  </md-layout>
                  <md-layout md-flex="10"></md-layout>
                  <md-layout md-flex="20" v-for="(item, index) in viewCargoDoc" :key="index">
                    <a :href="`${this.docURL}/FFExecutionSBWareHouse/` + item" target="_blank" download>View Document -
                      {{ index + 1 }}</a>
                  </md-layout>
                </md-layout>
                <hr class="hr-border" v-if="clientSBMultipleArry.length > 0" />
              </div>
              <div class="box" v-if="clientSBMultipleArry.length > 0">
                <div class="box-header">
                  <h4 class="box-title">
                    <u>All Client Shipping Details</u>
                  </h4>
                </div>

                <!-- /.box-header -->
                <div class="box-body">
                  <table id="ffConClientSB" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Client Name</th>
                        <th>Shipping Bill No</th>
                        <th>Remove</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in clientSBMultipleArry" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td @click="viewEditSB(item)" class="showMoreData">
                          {{ item.myclientName }}
                        </td>
                        <td @click="viewEditSB(item)" class="showMoreData">
                          {{ item.shippingBillNo }}
                        </td>
                        <td>
                          <md-button :disabled="item.Status == true" class="md-icon-button md-raised md-dense"
                            @click="removeCommon(item)">
                            <md-icon>delete_sweep</md-icon>
                          </md-button>
                          <!-- @click="removeSBDetailPOP(item)" -->
                        </td>
                        <!-- <td style="text-align:center;"><b-button @click="removeSBDetailPOP(item)" style="background-color:#d11a2a;">Remove</b-button></td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.box-body -->
              </div>
              <md-layout md-gutter v-if="
                sbLengthforAll.length == getMultipleClientArry.length &&
                getMultipleClientArry.length > 0
              ">
                <hr class="hr-border" />
                <!-- <md-layout md-flex="80"></md-layout> -->
                <md-layout md-flex="20" v-if="getMultipleClientArry.length > 0 && proceedNext == '1'">
                  <b-button variant="primary" @click="addFactoryExecution('VGM')" id="addButtonLoaderRail">Save &
                    Proceed to VGM</b-button>
                  <md-spinner md-indeterminate id="loaderRail" style="display: none"></md-spinner>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="mt-2" v-if="
                sbLengthforAll.length == getMultipleClientArry.length &&
                getMultipleClientArry.length > 0 && proceedNext == '1'
              ">
                <!-- <md-layout md-flex="80"></md-layout> -->
                <md-layout md-flex="20" v-if="proceedNext == '1'">
                  <b-button variant="primary" @click="addFactoryExecution('BLRaised')">Save & Proceed to raise
                    B/L</b-button>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="mt-2" v-if="
                sbLengthforAll.length == getMultipleClientArry.length &&
                getMultipleClientArry.length > 0 && proceedNext == '1'
              ">
                <!-- <md-layout md-flex="80"></md-layout> -->
                <md-layout md-flex="20" v-if="proceedNext == '1'">
                  <b-button variant="primary" @click="addFactoryExecution('handover')" id="addButtonLoaderRail">{{
                    ffExportDetail.portType == "Icd"
                      ? "Save & Proceed to Handover to Rail"
                      : "Save & Proceed to Gate ­ in at Terminal By Road"
                  }}</b-button>
                  <md-spinner md-indeterminate id="loaderRail" style="display: none"></md-spinner>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="mt-2" v-if="
                sbLengthforAll.length == getMultipleClientArry.length &&
                getMultipleClientArry.length > 0 && proceedNext == '1'
              ">
                <!-- <md-layout md-flex="80"></md-layout> -->
                <!-- <md-layout md-flex="20">
                  <b-button
                    variant="primary"
                    @click="addFactoryExecution('PAY')"
                    id="addButtonLoaderRail"
                  >{{"Save & Proceed to Sline Payment"}}</b-button>
                  <md-spinner md-indeterminate id="loaderRail" style="display:none"></md-spinner>
                </md-layout>
                <br/> -->
                <md-layout md-flex="20" v-if="proceedNext == '1'">
                  <span class="error">{{ AppovalMSG }}</span><br />
                  <!-- v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'" -->
                  <b-button class="mt-1" variant="primary" @click="addFactoryExecution('PAYTEST')"
                    id="addButtonLoaderVGM">Save & Proceed to Sline Payment</b-button><md-spinner md-indeterminate
                    id="loaderRail" style="display: none"></md-spinner>

                  <ResetSlineSubscription v-if="WarehouseStuffing.allModuleId && is_approval_mail_action>0"
                    :allModuleId="Number(WarehouseStuffing.allModuleId)" :JobNo="WarehouseStuffing.ffExportFclConsoSeries" @refresh-data="getData" />
                  <br  v-if="WarehouseStuffing.allModuleId && is_approval_mail_action>0" />
                </md-layout>
              </md-layout>
              <div md-gutter></div>
              <hr class="hr-s" />
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop2"
      @close="onClose"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop3"
      @close="onCloseSBDetails"></md-dialog-confirm>
  </div>
</template>
<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
// import BannerComponent from "../allModuleForm/bannerComponent.vue";
import BannerComponent from "../allModuleForm/trackingBannerComponent.vue";
import ClientUserService from "../../services/ClientUserService.js";
import ContainerComponent from "../allModuleForm/containerComponent.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import ResetSlineSubscription from '../common/ResetSlineSubscription.vue';

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/executionWHStuffingIcdCon");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    ContainerTypeSizefactory: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.ContainerTypeSizefactory.containerNo = newVal.containerNo.toUpperCase();
        }
      },
      deep: true,
    },
    WarehouseStuffing: {
      handler(newVal, oldVal) {
        if (this.WarehouseStuffing.packageId != "") {
          let arrayNew = this.packageNameList.filter((x) => {
            return x.packageId == this.WarehouseStuffing.packageId;
          });

          if (arrayNew.length > 0) {
            this.WarehouseStuffing.packageName = arrayNew[0].packageName;
          }
        }
      },
      deep: true,
    },
    SBDetail: {
      handler(newVal, oldVal) {
        if (this.SBDetail.packageId != "") {
          let arrayNew = this.packageNameList.filter((x) => {
            return x.packageId == this.SBDetail.packageId;
          });

          if (arrayNew.length > 0) {
            this.SBDetail.packageName = arrayNew[0].packageName;
          }
        }
      },
      deep: true,
    },
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  data() {
    return {
      syncFlag: false,
      ContainernoErrFlag: false,
      OldAssSeries_Containerno: "",
      ON_Type: "",
      ffSlinePayId: "",
      removingItem: [],
      selectDateFormat,
      allModuleId: "",
      trackingId: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      value12: "",
      CCdone: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      unitList: [
        {
          uT: "KGS",
          uV: "KGS",
        },
        {
          uT: "MT",
          uV: "MT",
        },
      ],
      getCLientData: [],
      getSBClientData: [],
      getPortType: ["dsd"],
      getContainerList: [],
      getLocationList: [],
      packageNameList: [],
      ffExportDetail: {
        portType: "",
        stuffingType: "",
        containerInfo: "",
        containerTypeId: "",
      },

      errorSBExecution: {
        clientId: "",
        shippingBillDate: "",
        shippingBillNo: "",

        cargoGrossWeight: "",
      },
      arraySBExecutionError: [
        "Please select client name",
        "Enter Shippping Bill Date",
        "Enter Shipping Bill No",
        "Enter Cargo Weight",
      ],
      errorAtleastSb: "",
      errorAtleastContainer: "",

      WarehouseStuffing: {
        ffConExecutionId: "",
        allModuleId: "",
        ffExportFclConsoSeries: "",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        stuffingType: "",
        portType: "",
        custmClearByPridel: "",
        ccAsignmentNo: "",
        containerInfo: "",
        fclConcontainerNo: "",
        containerTypeId: "",
        containerType: "",
        lineSealNo: "",
        customSealNo: "",
        tareWeight: "",
        conGrossWeight: "",
        cargoStuffingDate: "",
        handoverDate: "",
        execConClientId: "",
        nameOfCFS: "",
        packageName: "",
        packageId: "",
        noOfpkgUnit: "",
        measurement: "",
        netWeight: "",
        weightUnit: "",

        vgmSubmissionDate: "",
        siSubmissionDate: "",
        trSubmissionDate: "",
      },

      errorMainExecution: {
        nameOfCFS: "",
        containerTypeId: "",
        packageId: "",
        noOfpkgUnit: "",
        measurement: "",
      },
      arrayMainExecutionError: [
        "Please enter name of cfs",
        "Please select Container Type Id",
        "Please enter package name",
        "Please enter no of package",
        "Please enter measurement",
      ],
      clientDataModel: {
        execConClientId: "",
        ffConExecutionId: "",
        fclConsoMultipleClientId: "",

        cartingDate: "",
        crnNumber: "",
        clientId: "",
        clientName: "",
        vgmUpload: "",
        conshippingSBId: "",
      },

      errorClientList: {
        clientId: "",
        cartingDate: "",
        crnNumber: "",
      },
      errorArrayClient: [
        "Please select client name",
        "Please select carting date",
        "Please enter crn number",
      ],
      SBDetail: {
        conshippingSBId: "",
        clientId: "",
        clientName: "",
        execConClientId: "",
        ffConExecutionId: "",
        ffFclConsoExportId: "",
        shippingBillDate: "",
        shippingBillNo: "",
        cargoGrossWeight: "",
        invoiceUpload: "",
        cargoUpload: "",
        shippingBillDate: "",
        measurementCBM: "",
        leeoDate: "",
        leeoNo: "",
        netWeight: "",
        weightUnit: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },
      getMultipleClientArry: [],
      clientSBMultipleArry: [],
      sbDetailArray: [],
      showMoreSB: false,

      errorExecution: {
        cartingDate: "",
        crnNumber: "",
      },
      nameOfCFSError: "",
      arrayExecutionError: ["Select Carting Date", "Enter CRN Number"],

      ContainerTypeSizefactory: {
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        cargoStuffingDate: "",
        leeoDate: "",
        leeoNo: "",
        handoverDate: "",

        vgmSubmissionDate: "",
        siSubmissionDate: "",
        trSubmissionDate: "",
      },

      removeContainerVmodel: {
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
      },
      nextPageType: "",

      errorContainer: {
        containerTypeId: "",
        containerNo: "",
        cargoWeight: "",
      },
      sbLengthforAll: [],
      arrayContainerError: [
        // "Select Container Type",
        // "Enter Container No.",
        // "Enter Cargo Weight",
      ],
      editIndex: "",
      deleteId: "",
      showDivCountNote: false,
      BookingShippingLine: {},
      validateTrans: true,
      validateSB: true,
      containerTypeDetailFactory: [],
      containerNoRegexError: "",
      syncType: "",
      syncSeries: "",
      syncFlag: false,
      invnoErrFlag: false,
      AppovalMSG: '',
      is_approval_mail_action:0,
    };
  },

  mounted() { },

  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
    ContainerComponent,
    ResetSlineSubscription,
  },
  computed: {
    proceedNext() {
      return this.$store.getters.storeProceedContainer;
    },
    clientList() {
      return this.getCLientData;
    },

    clientListSbDetail() {
      return this.getSBClientData;
    },
    viewInvoicedDoc() {
      return this.SBDetail.invoiceUpload != ""
        ? this.SBDetail.invoiceUpload.split(",")
        : [];
    },
    viewCargoDoc() {
      return this.SBDetail.cargoUpload != "" ? this.SBDetail.cargoUpload.split(",") : [];
    },
    sbDetailArrayList() {
      return this.sbDetailArray;
    },
    containerTypeDetailFactoryList() {
      return this.containerTypeDetailFactory;
    },
    ContainerTypeList() {
      return this.getContainerList;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
    removeCommon(item, index) {
      //console.log("Shreshth Gahlot=>", item); return false;
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.isDocActive = item.isClientSBActive == "1" ? 0 : 1;
      let paylod = {
        tableName: "con_execwh_clientshipping",
        tableId: "conshippingSBId",
        tableIsActive: "isClientSBActive",
        value1: this.itemObj.isDocActive,
        tableVal: item.conshippingSBId,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    //TO Remove Client SHipping details
    removeSBDetailPOP(item) {
      this.alert.content = `You want to delete ${item.clientName}`;
      this.removingItem = item;
      this.$refs["addPop3"].open();
    },
    onCloseSBDetails(type) {
      if (type != "cancel") {
        this.removeSBDetail(this.removingItem);
      }
    },
    removeSBDetail(item) {
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/deleteFFConSBDetails.php`,
        data: JSON.stringify(item),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          if (result) {
            console.log(result);
            this.clientSBMultipleArry = this.clientSBMultipleArry.filter(
              (e) => !(e.conshippingSBId == item.conshippingSBId)
            );
          }
        })
        .catch((err) => console.log(err));
    },
    containerNoRegexfun_bak() {
      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      if (containerformat.test(this.WarehouseStuffing.fclConcontainerNo)) {
        this.containerNoRegexError = "";
      } else if (this.WarehouseStuffing.fclConcontainerNo == "") {
        this.containerNoRegexError = "Please enter container number";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
      }
    },
    async containerNoRegexfun() {
      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      let checkValueExit = await this.checkContainerNoExist();

      // alert(checkValueExit);

      if (containerformat.test(this.WarehouseStuffing.fclConcontainerNo)) {
        if (!checkValueExit) {
          this.containerNoRegexError = this.containerNoRegexError;
        } else {
          this.containerNoRegexError = "";
        }
      } else if (this.WarehouseStuffing.fclConcontainerNo == "") {
        if (!checkValueExit) {
          this.containerNoRegexError = this.containerNoRegexError;
        } else {
          this.containerNoRegexError = "Please enter container number";
        }
      } else {
        this.containerNoRegexError = "Enter Valid Format";
      }
    },
    checkContainerNoExist() {
      // alert(this.allModuleIdContainer);
      return new Promise((resolve) => {
        let option_details = {
          module_type: "FF Export",
          containerNo: this.WarehouseStuffing.fclConcontainerNo,
          goodReceivedID: "",
          allModuleId: this.allModuleId,
        };
        // alert(this.option_details.length);
        console.log("option_details=>", option_details);
        if (option_details != "") {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_SlineBillingCCExport/checkContainerNoExist.php`,
            data: JSON.stringify(option_details),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                console.log(data);
                console.log(data.find);
                // alert(data.find);
                if (data.find == 1) {
                  this.ContainernoErrFlag = true;
                  this.containerNoRegexError = data.MSG;
                  this.OldAssSeries_Containerno = "";
                  //  if(this.goodReceived.containerNo == data.containerNo){
                  //     this.containerNoRegexError = '';
                  //  }
                } else if (data.find == 0) {
                  this.ContainernoErrFlag = false;
                  this.containerNoRegexError = "";
                }

                this.syncFlag = true;
                console.log("Check");
                return resolve(!this.ContainernoErrFlag);
              }
            })
            .catch((error) => { });
        }
      });
    },
    addVgm() {
      this.$router.push({
        path: "/ffExportCon/fclConsoVgm",
      });
    },
    viewEdit(item) {
      Object.keys(this.clientDataModel).map((x) => {
        this.clientDataModel[x] = item[x];
      });
    },

    viewEditSB(item) {
      Object.keys(this.SBDetail).map((x) => {
        this.SBDetail[x] = item[x];
      });
    },
    onClose(type) {
      this.$sessionsStorage.set("editSalesExId", "");
      this.$sessionsStorage.set("editSalesExId", this.WarehouseStuffing.allModuleId);
      //alert(type);

      // if (
      //     this.ffExportDetail.portType == "Icd" &&
      //     this.nextPageType == "handover"
      //   )

      if (type != "cancel") {
        //alert(this.ffExportDetail.portType+" : "+this.nextPageType);
        if (
          // this.ffExportDetail.portType == "Icd" &&
          this.nextPageType == "handover"
        ) {
          //   alert(this.nextPageType)
          this.$router.push({
            path: "/ffExportCon/fclConsoHandOverToRail",
          });
        } else if (this.nextPageType == "VGM") {
          this.$router.push({
            path: "/ffExportCon/fclConsoVgm",
          });
        } else if (this.nextPageType == "BLRaised") {
          this.$router.push({
            path: "/ffExportCon/conFclBLofLanding",
          });
        } else if (this.nextPageType == "PAY") {
          console.log("Next page => ", this.nextPageType);
          this.$router.push({
            path: "/ffExportCon/ffConSLinePaymentExport",
          });

          // this.$router.push({
          //   path: "/ffExportCon/conFclBLofLanding"
          // });
        } else if (this.nextPageType == "PAYTEST") {
          // alert(this.ON_Type);
          // alert(this.ffSlinePayId);
          if (
            this.ON_Type == "New" ||
            this.ffSlinePayId == "" ||
            this.ffSlinePayId == undefined
          ) {
            this.$router.push({
              path: "/freightForward/ffConSLinePaymentExport_VP",
              // path: "/freightForward/ffSLinePaymentExportNew",
            });
          } else {
            this.$router.push({
              path: "/ffExportCon/ffConSLinePaymentExport",
            });
          }
          // this.$router.push({
          //   path: "/freightForward/ffConSLinePaymentExport_VP",
          //   // path: "/freightForward/ffSLinePaymentExportNew",
          // });
        }
      } else {
        console.log(type);
      }
    },

    showMoreSBDet() {
      if (this.showMoreSB == false) {
        this.showMoreSB = true;
      } else {
        this.showMoreSB = false;
      }
    },
    validateMultipleClient() {
      let validate_new = true;

      Object.keys(this.errorClientList).map((x, index) => {
        if (this.clientDataModel[x] == "") {
          this.errorClientList[x] = this.errorArrayClient[index];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validateTrans = true;
      } else {
        this.validateTrans = false;
      }
    },
    addClientWithMain() {
      if (this.WarehouseStuffing.containerTypeId != "") {
        let arrayContainer = this.getContainerList.filter((x) => {
          return x.containerTypeId == this.WarehouseStuffing.containerTypeId;
        })[0];
        this.WarehouseStuffing.containerType = arrayContainer.containerType;
      }
      if (
        this.getCLientData.length > 0 &&
        this.clientDataModel.execConClientId == "" &&
        this.clientDataModel.clientId != ""
      ) {
        let arrayClient = this.getCLientData.filter((x) => {
          return x.clientId == this.clientDataModel.clientId;
        })[0];
        this.clientDataModel.clientName = arrayClient.clientName;
        this.clientDataModel.fclConsoMultipleClientId =
          arrayClient.fclConsoMultipleClientId;
      }

      this.validateMultipleClient();
      this.clientDataModel["ffFclConsoExportId"] = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      let newData = {
        WareHouseModelMain: this.WarehouseStuffing,
        clientModelMain: this.clientDataModel,
        onlyExecMain: "",
      };

      if (this.validateTrans != false) {
        $("#addButtonLoaderC").css("display", "none");
        $("#loaderC").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addConsoExectuationWH.php`,
          data: JSON.stringify(newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$sessionsStorage.set("editffConExecutionId", data.ffConExecutionId);
              $("#loaderC").css("display", "none");
              $("#addButtonLoaderC").css("display", "block");
              this.WarehouseStuffing.ffConExecutionId = data.ffConExecutionId;
              this.getData();

              if (this.clientDataModel.execConClientId != "") {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
              Object.keys(this.clientDataModel).map((x) => {
                this.clientDataModel[x] = "";
              });
              Object.keys(this.errorClientList).map((x) => {
                this.errorClientList[x] = "";
              });
            }
          })
          .catch((error) => { });
      }
    },

    previousSalesView() {
      this.$router.push({
        path: "/ffExportCon/fclConsoBookingOrder",
      });
    },

    validateExecution() {
      let validate_new = true;
      Object.keys(this.errorMainExecution).map((x, index) => {
        if (this.WarehouseStuffing[x] == "") {
          this.errorMainExecution[x] = this.arrayMainExecutionError[index];
          validate_new = false;
        }
      });

      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      if (containerformat.test(this.WarehouseStuffing.fclConcontainerNo)) {
        this.containerNoRegexError = "";
      } else if (this.WarehouseStuffing.fclConcontainerNo == "") {
        this.containerNoRegexError = "Please enter container number";
        validate_new = false;
      } else {
        this.containerNoRegexError = "Enter Valid Format";
        validate_new = false;
      }

      if (validate_new == false) {
        window.scroll(0, 20);
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
    },
    checkSlinePayment() {
      return new Promise((resolve) => {
        let payLoad = {
          module_type: "FF Export",
          allModuleId: this.allModuleId,
          assignment_no: this.WarehouseStuffing.ffExportFclConsoSeries,
          type: this.TYPE,
        };
        // console.log("MypayLoad=>",payLoad.length);return false;
        if (payLoad != "") {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_SlineBillingCCExport/checkSlinePaymentcreated.php`,
            data: JSON.stringify(payLoad),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                console.log(data);
                console.log(data.find);
                if (data.find == 1) {
                  this.invnoErrFlag = true;
                  this.syncType = data.moduleType;
                  this.syncSeries = data.mainSalesSeries;
                } else if (data.find == 0) {
                  this.invnoErrFlag = false;
                }
                this.syncFlag = true;
                return resolve(!this.invnoErrFlag);
              }
            })
            .catch((error) => { });
        }
      });
    },
    verifyJoBWiseContainer() {
      return new Promise((resolve) => {
        let payLoad = {
          module_type: "FF Export",
          allModuleId: this.allModuleId,
        };
        // console.log("MypayLoad=>",payLoad.length);return false;
        NodeLockPannelService.verifyContainer(payLoad)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log("data PS=>", data);

            return resolve(data);
          })
          .catch((error) => {
            console.log("Catch on verifyJoBWiseContainer Error: ", error);
          });
      });
    },
    async addFactoryExecution(id) {
      this.nextPageType = id;
      if (id == "PAYTEST") {
        let checkContValueExit = await this.verifyJoBWiseContainer();
        console.log('checkContValueExit=>', checkContValueExit.data[0])

        if (!checkContValueExit.data[0].isCountMatching && checkContValueExit.data[0].subsFailedStatus) {
          this.alert.content = checkContValueExit.message;
          this.$refs["addPop"].open();
          return false;
        }

        let checkValueExit = await this.checkSlinePayment();
        console.log("checkValueExit", checkValueExit);

        if (!checkValueExit) {
          if (this.syncType != "FF Export") {
            this.alert.content =
              "The Payment Request has Already been Raised in '" +
              this.syncType +
              "' Assignment No. '" +
              this.syncSeries +
              "'";
            this.$refs["addPop"].open();
            return false;
          }
        }
      }
      // this.validateExecution();

      console.log("Next page => ", this.nextPageType);

      if (this.validateSB != false) {
        if (this.WarehouseStuffing.containerTypeId != "") {
          let arrayContainer = this.getContainerList.filter((x) => {
            return x.containerTypeId == this.WarehouseStuffing.containerTypeId;
          })[0];
          this.WarehouseStuffing.containerType = arrayContainer.containerType;

          this.WarehouseStuffing.allModuleId = this.allModuleId;
        }
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addConWareHouseExecution.php`,
          data: JSON.stringify(this.WarehouseStuffing),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$sessionsStorage.set("editFFExecutionId", data.ffConExecutionId);
              this.WarehouseStuffing.ffConExecutionId = data.ffConExecutionId;
              if (id == "handover") {
                $("#loaderRail").css("display", "none");
                $("#addButtonLoaderRail").css("display", "block");
              }

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop2"].open();
              }

              this.getData();
            }
          })
          .catch((error) => { });
      }
    },
    validateSBDetail() {
      let validate_new = true;
      Object.keys(this.errorSBExecution).map((x, index) => {
        if (this.SBDetail[x] == "") {
          this.errorSBExecution[x] = this.arraySBExecutionError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
    },
    addSBDetail() {
      let array_new = this.getMultipleClientArry;

      this.SBDetail.ffFclConsoExportId = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      this.SBDetail.ffConExecutionId = this.$sessionsStorage.get("editffConExecutionId");

      this.validateSBDetail();

      if (this.validateSB != false) {
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");
        let arrayClientName = array_new.filter((x) => {
          return x.clientId == this.SBDetail.clientId;
        })[0];
        this.SBDetail.clientName = arrayClientName.clientName;
        this.SBDetail.execConClientId = arrayClientName.execConClientId;

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addSBClientExection.php`,
          data: JSON.stringify(this.SBDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.getData();
              if (this.SBDetail.conshippingSBId != "") {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
              $("#loaderSB").css("display", "none");
              $("#addButtonLoaderSB").css("display", "block");
              Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] = "";
              });

              Object.keys(this.errorSBExecution).map((x) => {
                this.errorSBExecution[x] = "";
              });
            }
          })
          .catch((error) => { });
      }
    },

    onFileChangeInvoice() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaExport/FFExecutionInvoiceSBWareHouse.php`,
          formData,
          config
        )
        .then((result) => {
          this.SBDetail.invoiceUpload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    onFileChangeCargo() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaExport/FFExecutionCargoSBWareHouse.php`,
          formData,
          config
        )
        .then((result) => {
          this.SBDetail.cargoUpload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    getData() {
      // alert(this.allModuleId);
      this.doLoading();
      if (this.sbDetailArrayList.length == 1) {
        this.sbDetailArray = [];
      }
      if (this.containerTypeDetailFactory.length == 1) {
        this.containerTypeDetailFactory = [];
      }
      if (this.getContainerList.length == 1) {
        this.getContainerList = [];
      }
      let new_data = {
        clientId: "clientId",
        // allModuleID:this.allModuleId,
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        conFclBookingId:
          this.$sessionsStorage.get("editconFclBookingId") != "" &&
            this.$sessionsStorage.get("editconFclBookingId") != undefined
            ? this.$sessionsStorage.get("editconFclBookingId")
            : "",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToFFExportExConso.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.containerMaster.length > 0) {
              this.getContainerList = data.containerMaster;
            }
            if (data.clientNamesDetails.length > 0) {
              this.getCLientData = data.clientNamesDetails;
            } else {
              this.getCLientData = [];
            }
            // alert(data.ffseaType);
            console.log("ffseaType_query=>", data.ffseaType_query);
            console.log("ffseaType=>", data.ffseaType);
            this.ON_Type = data.ffseaType;
            this.ffSlinePayId = data.ffSlinePayId;

            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }
            if (data.SbCountDone.length > 0) {
              this.sbLengthforAll = data.SbCountDone;
            }

            if (data.fclMainPageData.length > 0) {
              this.allModuleId = data.fclMainPageData[0].allModuleId;
              this.AppovalMSG = data.fclMainPageData[0].AppovalMSG;
              this.is_approval_mail_action = data.fclMainPageData[0].is_approval_mail_action;
              Object.keys(this.ffExportDetail).map((x) => {
                this.ffExportDetail[x] = data.fclMainPageData[0][x] || "";
              });
            }
            this.WarehouseStuffing.containerTypeId = this.ffExportDetail.containerTypeId;

            if (data.ffConExectionDetail.length > 0) {
              Object.keys(data.ffConExectionDetail[0]).map((x) => {
                this.WarehouseStuffing[x] = data.ffConExectionDetail[0][x] || "";
              });
            } else {
              this.WarehouseStuffing.containerTypeId = this.ffExportDetail.containerTypeId;
            }
            if (data.ffConExecClientDetail.length > 0) {
              this.getMultipleClientArry = data.ffConExecClientDetail;
            }

            this.getSBClientData = this.getMultipleClientArry;

            if (data.clientSBData.length > 0) {
              this.clientSBMultipleArry = data.clientSBData;
            }

            this.WarehouseStuffing.ffExportFclConsoSeries =
              data.fclMainPageData[0].ffExportFclConsoSeries;
            this.WarehouseStuffing.allModuleId = data.fclMainPageData[0].allModuleId;

            if (data.conBLData.length > 0) {
              data.clientSBData.forEach((e, i) => {
                data.conBLData.forEach((e2) => {
                  if (e.clientName == e2.clientName) {
                    this.clientSBMultipleArry[i]["Status"] = true;
                    return true;
                  }
                });
              });
            }
            console.log(this.clientSBMultipleArry);
            this.getTrackingDetails();
            this.doLoadingClose();
          }
        })
        .catch((error) => { });
    },

    getTrackingDetails() {
      let new_data = {
        allModuleId: this.WarehouseStuffing.allModuleId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.BIdType && data.BIdType.length > 0) {
              this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
              this.trackingId = data.BIdType[0].id;
            } else {
              this.trackingId = "";
            }
          }
        })
        .catch((error) => { });
    },

    JqueryFun() {
      return $(function () {
        $("#ffConClient").DataTable();
        $("#ffConClientSB").DataTable();
      });
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// executionWHStuffingIcdCon.vue?754e5af0